module.exports = __webpack_public_path__ + "img/Trash.992601a6.svg";